export default "__VITE_ASSET__D$MhwfKZ__"